"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextArea_1 = require("./TextArea");
exports.default = TextArea_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/TextArea/index.js
// module id = 1821
// module chunks = 8